/**
 * Action step component. User can add any amount of these.
 */
import React, { PropTypes } from 'react';

function ActionStep({ addActionStep, index, stepData, updateActionStep }) {
  const onStepChange = (evt) => {
    const stepValue = evt.target.value;
    updateActionStep(index, { stepValue });
  };
  const onTimeChange = (evt) => {
    const timeValue = evt.target.value;
    updateActionStep(index, { timeValue });
  };
  const onKeyDown = (evt) => {
    if (evt.keyCode === 13) {
      addActionStep();
    }
  };
  return (
    <div>
      <span>I will</span>
      <input
        defaultValue={stepData ? stepData.stepValue : null}
        onChange={onStepChange}
        onKeyDown={onKeyDown}
        placeholder="I will take a particular action"
        type="text"
      />
      <input
        defaultValue={stepData ? stepData.timeValue : null}
        onChange={onTimeChange}
        onKeyDown={onKeyDown}
        placeholder="at a particular time"
        type="text"
      />
    </div>
  );
}

ActionStep.propTypes = {
  addActionStep: PropTypes.func,
  index: PropTypes.number,
  stepData: PropTypes.shape({}),
  updateActionStep: PropTypes.func,
};

export default ActionStep;



// WEBPACK FOOTER //
// js/src/goals/ActionStep.js